"use client";

import { useRouter } from "next/navigation";

export default function LogoutButton() {
  const router = useRouter();

  async function handleLogout() {
    await fetch("/api/auth/logout", { method: "POST" });
    router.push("/login");
    router.refresh();
  }

  return (
    <button
      onClick={handleLogout}
      className="text-sm text-[hsl(243,15%,50%)] hover:text-[hsl(0,60%,46%)] px-3 py-2 rounded-lg hover:bg-[hsl(0,84%,97%)] transition-colors font-medium"
    >
      Sign out
    </button>
  );
}
